<template>
	<div class="imain1">
		<div class="mainbox">
			<div class="ititle wow fadeInUp">{{ t('detail.remenyouhui') }}</div>
			<div class="ideals_list">
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoHotDeals('1')">
						<div class="img"><img src="@/assets/images/index/hot1.jpg" /></div>
						<div class="more">{{ t('detail.chakanquanbu') }}</div>
						<div class="tit">
							<div class="t">{{ t('detail.remenyouhui') }}</div>
							<div class="m">{{ t('productList.lvyoucuxiao') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoHotDeals('2')">
						<div class="img"><img :src="getAssetsHotDealFile('002/banner.jpg')" /></div>
						<div class="more">{{ t('detail.chakanquanbu') }}</div>
						<div class="tit">
							<div class="t">{{ t('detail.remenyouhui') }}</div>
							<div class="m">{{ t('productList.guanzhuwomen') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoHotDeals('3')">
						<div class="img"><img :src="getAssetsHotDealFile('003/banner.jpg')" /></div>
						<div class="more">{{ t('detail.chakanquanbu') }}</div>
						<div class="tit">
							<div class="t">{{ t('detail.remenyouhui') }}</div>
							<div class="m">{{ t('productList.miyuetaocan') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoHotDeals('4')">
						<div class="img"><img :src="getAssetsHotDealFile('004/banner.jpg')" /></div>
						<div class="more">{{ t('detail.chakanquanbu') }}</div>
						<div class="tit">
							<div class="t">{{ t('detail.remenyouhui') }}</div>
							<div class="m">{{ t('productList.lvyoucuxiaohuodong') }}</div>
						</div>
					</a>
				</div>
				<div class="item wow fadeInUp">
					<a href="javascript:void(0)" class="item_m" @click="handleGoHotDeals('5')">
						<div class="img"><img :src="getAssetsHotDealFile('005/banner.jpg')" /></div>
						<div class="more">{{ t('detail.chakanquanbu') }}</div>
						<div class="tit">
							<div class="t">{{ t('detail.remenyouhui') }}</div>
							<div class="m">{{ t('productList.dujiatiantang') }}</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
//@ts-ignore
import { routeGo } from '@/hooks/web/jumpGo';
import { useI18n } from 'vue-i18n';
import { getAssetsHotDealFile } from '@/utils/getImgUrl';
const { t } = useI18n();
function handleGoHotDeals(id: string) {
	// if (id === '1') {
	routeGo('hotDeals', id);
	// }
}
</script>

<style lang="scss" scoped>
.ideals_list .item {
	.img {
		z-index: 0;
	}
	.tit {
		z-index: 0;
	}
	.more {
		z-index: 0;
	}
}
</style>
